module.exports = __webpack_public_path__ + "static/media/basic.eeccfaae.png";